<template>
  <div class="content">
    <div class="box">
      <p class="title">总部及下属机构</p>
      <div class="item-content" v-for="item in LIST" :key="item.id">
        <!-- <img class="item-img" :src="item.url" /> -->
        <ffcs-img class="item-img" :fileCode="item.url"/>
        <div class="item-box">
          <p class="item-title">{{ item.title }}</p>
          <div class="item-content-content" style="height: 219px; width: 685px">
            <p class="item-desc01">{{ item.desc01 }}</p>
            <p class="item-desc01">{{ item.desc02 }}</p>
            <p class="item-title item-title-01" style="margin-top: 27px">
              地址:
            </p>
            <p class="item-desc01">{{ item.address }}</p>
            <p class="item-title item-title-01">工作时间:</p>
            <p class="item-desc01" v-html="item.workTime"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const LIST = [
  {
    title: "福州总部",
    desc01: "福建省外国机构服务中心",
    desc02: "福建省友好国际旅行社有限公司",
    address: "福建省福州市鼓楼区华林路97号省外办大楼1到7层",
    workTime:
      "法定工作日 周一至周五 上午08:00—12:00 下午14:30—17:30（夏令时15:00~18:00）\n※一层办事服务大厅：法定工作日上午08:00~12:00 下午14:00~17:00（全年）",
    url: require("../../../assets/images/pic_organization_profile_list1.png"),
  },
  {
    title: "北京送签点",
    desc01: "",
    desc02: "",
    address: "北京市朝阳区团结湖东里12号团结公寓",
    workTime: "法定工作日 周一至周五 上午09:00—11:30 下午14:30—17:30",
    url: require("../../../assets/images/pic_organization_profile_list2.png"),
  },
  {
    title: "广州送签点",
    desc01: "",
    desc02: "",
    address: "广州市越秀区华乐路34号广怡大厦",
    workTime: "法定工作日 周一至周五 上午09:00—11:30 下午14:30—17:30",
    url: require("../../../assets/images/pic_organization_profile_list.png"),
  },
  {
    title: "泉州服务处",
    desc01: "",
    desc02: "",
    address: "泉州市鲤城区涂门街中段益民楼 泉州市通淮公证处四楼9号认证窗口",
    workTime: "法定工作日 周一至周五 上午9：00~12：00，下午14：30~17：30",
    url: require("../../../assets/images/pic_organization_profile_list222.png"),
  },
  {
    title: "连江服务处",
    desc01: "",
    desc02: "",
    address: "福州市连江县凤城镇市民服务中心70号窗口",
    workTime: "法定工作日 周一至周五 上午9：00~12：00，下午14：30~17：30",
    url: require("../../../assets/images/ljfwzx.jpg"),
  },
];
import { getPicByPicCode } from "@/api/service.js";
import {getFileDetails} from '@/api/file.js'
export default {
  name: "mechanism",
  data() {
    return {
      LIST,
    };
  },
  mounted() {
    this.getLIST();
  },
  methods: {
    async getLIST() {
      
      try {
        
        let pic1 = await getPicByPicCode("RES3F45433B1314A8A"); //总部
        // let  url1 = '';
        // const img = await getFileDetails(this._.get(resI, 'data.appCode', ''), this._.get(resI, 'data.tenantCode'), [this._.get(resI, 'data.contentPicFileDtoList.0.fileCode', '')])
        //   url1=(this._.get(Object.values(this._.get(img, 'data')), '0'))
        // }
        console.log(pic1,'图片资源')
        let obj1 = {
          id:1,
          title: "福州总部",
          desc01: "福建省外国机构服务中心",
          desc02: "福建省友好国际旅行社有限公司",
          address: pic1.data.contentPicFileDtoList[0].picFileUrl,
          workTime: pic1.data.contentPicFileDtoList[0].picRemark.replace("\\n", "\n"),
          url: pic1.data.contentPicFileDtoList[0].fileCode,
        };
        // let
        let pic2 = await getPicByPicCode("RES803827CDFB10ADE"); //北京
        let obj2 = {
          id:2,
          title: "北京送签点",
          desc01: "",
          desc02: "",
          address: pic2.data.contentPicFileDtoList[0].picFileUrl,
          workTime: pic2.data.contentPicFileDtoList[0].picRemark,
          url: pic2.data.contentPicFileDtoList[0].fileCode,
        };
        let pic3 = await getPicByPicCode("RES01B6392F3F448B9"); //广州
        let obj3 = {
          id:3,
          title: "广州送签点",
          desc01: "",
          desc02: "",
          address: pic3.data.contentPicFileDtoList[0].picFileUrl,
          workTime: pic3.data.contentPicFileDtoList[0].picRemark,
          url: pic3.data.contentPicFileDtoList[0].fileCode,
        };
        let pic4 = await getPicByPicCode("RES4222FAD9981E15A"); //泉州
        // console.log(pic4,'泉州图片资源')
        let obj4 = {
          id: 4,
          title: "泉州服务处",
          desc01: "",
          desc02: "",
          address: pic4.data.contentPicFileDtoList[0].picFileUrl,
          workTime: pic4.data.contentPicFileDtoList[0].picRemark,
          url: pic4.data.contentPicFileDtoList[0].fileCode,
        };
        let pic5 = await getPicByPicCode("RES23B714B88538BF2"); //连江
        let obj5 = {
          id: 5,
          title: "连江服务处",
          desc01: "",
          desc02: "",
          address: pic5.data.contentPicFileDtoList[0].picFileUrl,
          workTime: pic5.data.contentPicFileDtoList[0].picRemark,
          url: pic5.data.contentPicFileDtoList[0].fileCode,
        };
        this.LIST = [obj1, obj2, obj3, obj4, obj5]
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped lang="less">
p {
  margin: 0;
  //margin-bottom: 19px;
  line-height: 40px;
}
.content {
  width: 100%;
  position: relative;
}
.box {
  width: 1140px;
  position: relative;
  margin: auto;
  margin-top: 59px;
  // left: 50%;
  // transform: translateX(-50%);
  background: #fff;
}
.title {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  text-align: left;
}
.item-content {
  width: 1140px;
  // height: 347px;
  background: #ffffff;
  border: 1px solid #decba4;
  margin: 40px 0;
  text-align: left;
  padding: 40px 50px;
}
.item-img {
  width: 200px;
  height: 267px;
  vertical-align: top;
  margin-right: 50px;
  display: inline-block;
}
.item-box {
  display: inline-block;
}
.item-title {
  //height: 24px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.item-desc01 {
  font-size: 18px;
  color: rgba(58, 58, 58, 1);
  height: 40px;
}
.item-title-01 {
  font-size: 18px;
  //margin-top: -12px;
}
.item-content-content > p {
  margin-top: 0 !important;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/institutionalOverview/siderContent02.vue